export const urlConfig = {
  showAppDownloadLinks: false,
  androidLink: 'https://play.google.com/store/apps/details?id=com.ddglobal.fortuber',
  iosLink: 'https://apps.apple.com/app/6760326678',
};